import { useState } from "react";
import { formatCurrency } from "@/pages/clients/clientsUtils";
import { useCustomerKPIs, fyBounds } from "@/pages/clients/hooks/useCustomerKPIs";
import { PillRail, Pill } from "@/components/common/Segmented";
import { InfoCard } from "@/components/workOrderTab/WOGeneralCard";

const Row = ({ label, value, tone = "", strong, testId, title }) => (
  <div className={`flex items-center justify-between gap-3 text-sm ${strong ? "font-semibold text-slate-900" : "text-slate-700"}`} data-testid={testId} title={title}>
    <span className={strong ? "" : "text-slate-500"}>{label}</span>
    <span className={`num ${tone}`}>{value}</span>
  </div>
);

// "Revenue" card on the customer General tab — lifetime totals with an All · This FY · Last FY toggle (FY = May–Apr).
export function ClientRevenueCard({ workOrders, proposals }) {
  const [windowKey, setWindowKey] = useState("all");
  const k = useCustomerKPIs(workOrders, proposals, { window: windowKey });
  const windows = [
    { key: "all", label: "All" },
    { key: "fy", label: `This FY`, title: `${fyBounds(0).label} · May–Apr` },
    { key: "last_fy", label: `Last FY`, title: `${fyBounds(-1).label} · May–Apr` },
  ];

  return (
    <InfoCard title="Revenue" testId="client-revenue-card" className="h-full">
      <PillRail testId="revenue-window-picker">
        {windows.map((w) => (
          <Pill key={w.key} on={windowKey === w.key} onClick={() => setWindowKey(w.key)} title={w.title} testId={`kpi-window-${w.key}`}>{w.label}</Pill>
        ))}
      </PillRail>
      <div className="space-y-1.5">
        <Row label="Total Revenue" value={formatCurrency(k.totalRevenue)} strong testId="kpi-total-revenue" title="Won + lost dollars (completed/cancelled work orders and won/lost proposals)" />
        <Row label="Won" value={formatCurrency(k.won)} tone="text-emerald-600" testId="kpi-won" />
        <Row label="Lost" value={formatCurrency(k.lost)} tone="text-red-600" testId="kpi-lost" />
        <Row label="Won / Bid" value={`${k.wonCount} / ${k.bidCount}`} testId="kpi-won-bid" title="Decided bids only — open proposals and active work orders are excluded" />
        <Row label="Hit Rate" value={`${k.hitRateCount}%`} tone="text-brand font-semibold" testId="kpi-hit-rate" title="Won ÷ decided bids (by count)" />
      </div>
    </InfoCard>
  );
}
